module.exports = __webpack_public_path__ + "img/28.c335753a.png";